import React, { useState, useRef, useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { DataObjectContainer } from '../dataObjects/DataObjectContextManager';
import { ApiDataAccess } from '../infrastructure/ApiDataAccess';
import { BoundLabel, PageableList, DataSourceDropdownList, BoundTextarea } from '../dataObjects/BoundControls';
import { Popup, Confirmation } from '../core/Popup';
import { Textbox } from '../core/Textbox';
import { XSquare, Eye } from 'react-feather';
import { ApplicationInfo } from '../components/ApplicationInfo';
import { Card } from '../core/Card';
import { UserContext, CapabilitiesContext } from '../infrastructure/Contexts';
import { CapabilityName } from '../infrastructure/Constants';


export const ReviewPage = () => {
    var timeout = null;
    const { applicationKey, source, target } = useParams();
    const context = useRef(null);
    const confirmation = useRef(null);
    const navigate = useNavigate();
    const popup = useRef(null);
    const list = useRef(null);
    const [recordKey, setRecordKey] = React.useState(null);
    const [filter, setFilter] = React.useState({ applicationclientid: applicationKey, sourceculture: source ? source : null, targetculture: target ? target : null, sourcephrasefilter: null, targetphrasefilter: null, validated: false });
    const userContext = useContext(UserContext);

    if (source.toLowerCase() != userContext.cultureString.toLowerCase()) {
        document.location = '/account/signout';
    }

    const onSaved = async () => {
        list.current.refresh();
    }

    const showPopup = (recordKey) => {
        setRecordKey(recordKey);
        popup.current.show();
    }

    const onSourceCultureChanged = (val) => {
        console.log(val);
        var f = filter;
        f['sourceculture'] = val ? val : null;
        setFilter(f);
        list.current.refresh();
    }

    const onTargetCultureChanged = (val) => {
        console.log(val);
        var f = filter;
        f['targetculture'] = val ? val : null;
        setFilter(f);
        list.current.refresh();
    }

    const onValidated = async (key) => {
        var dataAccess = new ApiDataAccess('/api/dataobjects/translationDataObject');
        await dataAccess.post(`/${key}/validate`);
        list.current.refresh();
    }

    const onSourcePhraseFilterChanged = (txt) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            var f = filter;
            f['sourcephrasefilter'] = txt ? txt : null;
            setFilter(f);
            list.current.refresh();

        }, 500);
    }

    const onCategoryFilterChanged = (txt) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            var f = filter;
            f['category'] = txt ? txt : null;
            setFilter(f);

            console.log(f);

            list.current.refresh();

        }, 500);
    }


    const onTargetPhraseFilterChanged = (txt) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            var f = filter;
            f['targetphrasefilter'] = txt ? txt : null;
            setFilter(f);
            list.current.refresh();

        }, 500);
    }

    return (
        <div>
            <Popup ref={popup}>
                <ApplyTranslationPopupContent popup={popup} onSaved={onSaved} recordKey={recordKey} />
            </Popup>

            <Confirmation ref={confirmation} />

            <Card title='Translation Review' subtitle='Please review the following translations. Press the confirm button when the translation is correct or select the row to make a change.'>
                <DataObjectContainer ref={context} dataObjectName={'translationDataObject'} >
                    <PageableList ref={list} pageSize={100} filter={filter} defaultText={'No Translations found. Please check the applied filters.'}
                        onRenderHeaderRow={() => {
                            return (
                                <div className='row caption' >
                                    <div className='cell mobile-hidden'>Category
                                        <DataSourceDropdown name={'DistinctCategories'} filter={filter} valuePropertyName={'Name'} onChanged={onCategoryFilterChanged} />
                                    </div>
                                    <div className='cell mobile-hidden'>
                                        Source Culture
                                        {!source &&
                                            <DataSourceDropdownList dataSourceName='DistinctSourceCultures' onChanged={onSourceCultureChanged} />
                                        }
                                    </div>
                                    <div className='cell'>
                                        Source Phrase
                                        <Textbox onChange={txt => { onSourcePhraseFilterChanged(txt) }} />
                                    </div>
                                    <div className='cell mobile-hidden'>
                                        Target Culture
                                        {!target &&
                                            <DataSourceDropdownList dataSourceName='DistinctTargetCultures' onChanged={onTargetCultureChanged} />
                                        }
                                    </div>
                                    <div className='cell'>
                                        Target Phrase
                                        <Textbox onChange={txt => { onTargetPhraseFilterChanged(txt) }} />
                                    </div>
                                    <div className='cell mobile-hidden text-align-right'>&nbsp;</div>
                                </div>
                            )
                        }}
                        onRenderRow={(key, item, references) => {
                            return (
                                <div className='row selectable' key={`row${key}`}>
                                    
                                    <div className='cell mobile-hidden' onClick={() => { showPopup(key) }}>{item.category}</div>
                                    <div className='cell mobile-hidden' onClick={() => { showPopup(key) }}>
                                        <span className={`fi fi-${references.dataSources.sourceCultureId.find(e => e.id == item.sourceCultureId).countryCode}`}></span>
                                        <span>{references.dataSources.sourceCultureId.find(e => e.id == item.sourceCultureId).languageName}</span>
                                    </div>

                                    <div className='cell' onClick={() => { showPopup(key) }}>{item.sourceVocablePhrase}</div>

                                    <div className='cell mobile-hidden' onClick={() => { showPopup(key) }}>
                                        <span className={`fi fi-${references.dataSources.targetCultureId.find(e => e.id == item.targetCultureId).countryCode} mobile-hidden`}></span>
                                        <span>{references.dataSources.targetCultureId.find(e => e.id == item.targetCultureId).languageName}</span>
                                    </div>

                                    <div className='cell' onClick={() => { showPopup(key) }}>{item.targetVocablePhrase}</div>

                                    <div className='cell mobile-hidden text-align-right'>
                                        <button className='btn sm btn-primary-outline' onClick={() => { onValidated(key) }}><Eye className='icon' /> Confirm</button>
                                    </div>

                                </div>
                            )
                        }} />
                </DataObjectContainer>
            </Card>
        </div>
    );
}


export const DataSourceDropdown = ({ name, filter, valuePropertyName, onChanged }) => {

    const [items, setItems] = useState(null);

    useEffect(() => {

        const init = async () => {

            var filterStr = "";
            if (filter) {
                Object.keys(filter).forEach(key => {
                    filterStr += `&${key}=${encodeURIComponent(filter[key])}`;
                });
            }

            var dataAccess = new ApiDataAccess('/api/datasources');
            var items = await dataAccess.get(`/${name}?filter=${filterStr}`);
            setItems(items);
        }

        init();

    }, []);



    const onSelection = (event) => {
        if (onChanged) {
            onChanged(event.target.value)
        }
    }

    return (
        <>
            {items &&
                <select className={`control dropdown ${name}`} onChange={onSelection}>
                    <option value={''}>All</option>
                    {items.map((item, i) => {
                        return (
                            <option key={i} value={item[valuePropertyName]}>{item.name}</option>
                        )
                    })}
                </select>
            }
        </>
    )
}


export const ApplyTranslationPopupContent = ({ popup, recordKey, onSaved }) => {

    const context = useRef(null);
    const [valid, setValid] = useState(false);
    const capabilities = useContext(CapabilitiesContext);
    const notification = capabilities.getCapability(CapabilityName.Notification);

    const onSaveClick = async () => {
        popup.current.close();
        try {
            var response = await context.current.submitAsync();

            if (onSaved) {
                onSaved(response);
            }
        }
        catch (ex) {
            var error = JSON.parse(ex);
            console.log(error);
            notification.add('error', 'Error', error.detail ? error.detail : 'The translation was not saved. Make sure that all tokens from the source phrase are used in the translation.');
        }
    }

    return (
        <DataObjectContainer ref={context} dataObjectName={'translationDataObject'} dataObjectId={recordKey} onValidated={valid => { setValid(valid) }} >
            <div className='topSection'>
                <div className='left'></div>
                <div className='center'><h4>New Translation</h4></div>
                <div className='right'><XSquare className='icon btn-close clickable' onClick={() => { popup.current.close() }} /></div>
            </div>

            <div className='contentSection'>

                <label htmlFor='key'>Key</label>
                <p><BoundLabel propertyName={'sourceCultureId'} />-<BoundLabel propertyName={'key'} />-<BoundLabel propertyName={'keyVariant'} />-<BoundLabel propertyName={'targetCultureId'} /></p>

                <label htmlFor='sourceVocablePhrase'>Source Vocable Phrase</label>
                <p><b><BoundLabel propertyName={'sourceVocablePhrase'} /></b></p>


                <label htmlFor='targetVocablePhrase'>Target Vocable Phrase</label>
                <BoundTextarea propertyName={'targetVocablePhrase'} rows={5} />

            </div>

            <div className='footerSection'>
                <button className='btn btn-primary btn-modal' onClick={() => { popup.current.close(); }}>Cancel</button>
                <button className='btn btn-secondary btn-modal' disabled={!valid} onClick={onSaveClick}>Save</button>
            </div>
        </DataObjectContainer>
    );
}

